// Today's date as YYYY-MM-DD in Phuket time, identical on the SSR server and
// in the browser. The public pages feed it to <DateField :min>; computing it
// with `new Date().toLocaleDateString()` gave the server's UTC day and the
// visitor's local day, which differ for seven hours around midnight and made
// Vue report a hydration mismatch on every boat page (review 2026-10-29).
const fmt = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Bangkok', year: 'numeric', month: '2-digit', day: '2-digit' })

export function phuketToday() {
  return fmt.format(new Date())
}
